import { resolveProviderConfigs } from "../providers/resolve.js";
import { parseCoreProviderConfig } from "./provider-core.js";
import { parseSentryProviderConfig } from "../providers/sentry/schema.js";

export {
  DEFAULT_CONSOLE_PROVIDER,
  type ConsoleProviderConfig,
  type HttpProviderConfig,
  type CallbackProviderConfig,
  type CoreProviderConfig,
} from "./provider-core.js";

export type {
  SentryProviderConfig,
  SentryFeaturesConfig,
  SentryTracingOptions,
  SentryReplayOptions,
  SentryProfilingOptions,
  SentryLogsOptions,
  SentryReactRouterOptions,
} from "../providers/sentry/schema.js";

export { parseSentryFeatures } from "../providers/sentry/schema.js";

import type { CoreProviderConfig } from "./provider-core.js";
import type { SentryProviderConfig } from "../providers/sentry/schema.js";

export type ProviderConfig = CoreProviderConfig | SentryProviderConfig;

export function parseProviderConfig(input: unknown): ProviderConfig {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    throw new Error("[telemetry] provider must be an object");
  }
  const type = (input as Record<string, unknown>).type;
  if (type === "sentry") {
    return parseSentryProviderConfig(input);
  }
  return parseCoreProviderConfig(input);
}

export function parseProviderConfigs(input: unknown): ProviderConfig[] {
  if (input === undefined) {
    return resolveProviderConfigs(undefined);
  }
  if (!Array.isArray(input)) {
    throw new Error("[telemetry] providers must be an array");
  }
  return resolveProviderConfigs(input.map(parseProviderConfig));
}
